import { Canvas } from "@react-three/fiber";
import { OrbitControls } from "@react-three/drei";
import { useState } from "react";
import JawModel from "../components/dental/JawModel";
import ToothPanel from "../components/dental/ToothPanel";

export default function DentalViewer() {

  const [selectedTooth, setSelectedTooth] = useState(null);

  return (
    <div style={{height:"100%", display:"flex"}}>

      <div style={{flex:1}}>

        <Canvas camera={{position:[0,2,6]}}>

          <ambientLight intensity={1}/>
          <directionalLight position={[5,5,5]}/>

          <JawModel onSelectTooth={setSelectedTooth} />

          <OrbitControls/>

        </Canvas>

      </div>

      <ToothPanel toothId={selectedTooth} />

    </div>
  );
}